const facilities = [
  {
    name: "Kingsport Main Post Office",
    type: "USPS Acceptance Facility",
    address: "201 New Kingsport Hwy, Kingsport, TN 37660",
    hours: "Mon–Fri 8:30 AM – 5:00 PM",
    phone: "(423) 246-4171",
    notes: "Full passport acceptance services. Appointments recommended. Primary facility for Kingsport residents and Eastman Chemical employees in the downtown area.",
    icon: "ri-mail-line",
    featured: true,
  },
  {
    name: "Church Hill Post Office",
    type: "USPS Acceptance Facility",
    address: "215 E Main Blvd, Church Hill, TN 37642",
    hours: "Mon–Fri 9:00 AM – 4:30 PM",
    phone: "(423) 357-8105",
    notes: "Passport acceptance for Hawkins County and western Sullivan County residents. Convenient for Church Hill and Mount Carmel area travelers.",
    icon: "ri-mail-line",
    featured: false,
  },
  {
    name: "Gate City, Virginia Post Office",
    type: "USPS Acceptance Facility",
    address: "149 Shoemaker St, Gate City, VA 24251",
    hours: "Mon–Fri 9:00 AM – 4:00 PM",
    phone: "(276) 386-6205",
    notes: "Serves Scott County VA residents near the Tennessee border. Many Gate City residents work at Eastman and use this facility for passport acceptance.",
    icon: "ri-mail-line",
    featured: false,
  },
  {
    name: "Bristol, Tennessee Post Office",
    type: "USPS Acceptance Facility",
    address: "1015 State St, Bristol, TN 37620",
    hours: "Mon–Fri 9:00 AM – 4:30 PM",
    phone: "(423) 989-4631",
    notes: "Located on the famous State Street TN/VA border. Serves the entire Bristol community on both sides — only 18 miles from Kingsport.",
    icon: "ri-mail-line",
    featured: false,
  },
  {
    name: "Rogersville Post Office",
    type: "USPS Acceptance Facility",
    address: "100 E Main St, Rogersville, TN 37857",
    hours: "Mon–Fri 9:00 AM – 4:00 PM",
    phone: "(423) 272-7700",
    notes: "Hawkins County seat facility. Convenient for Rogersville and eastern Hawkins County residents connected to the Kingsport industrial corridor.",
    icon: "ri-mail-line",
    featured: false,
  },
];

export default function KingsportAcceptanceFacilitiesSection() {
  return (
    <section id="facilities" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Facilities</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Passport Acceptance Facilities Near Kingsport
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            These facilities handle in-person acceptance for first-time applicants and minors. Eastman Chemical employees and adults renewing can skip the facility visit entirely with our mail service.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">
          {facilities.map((f, i) => (
            <div key={i} className={`rounded-xl p-7 border ${f.featured ? "border-[#F6C344] bg-[#F6C344]/5" : "border-gray-200 bg-white"} flex flex-col`}>
              {f.featured && (
                <span className="inline-block bg-[#F6C344] text-[#1A365D] text-xs font-bold px-3 py-1 rounded-full mb-4 self-start">Primary Location</span>
              )}
              <div className="flex items-start gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                  <i className={`${f.icon} text-[#1A365D] text-lg`}></i>
                </div>
                <div>
                  <h3 className="font-semibold text-[#1A365D] text-base">{f.name}</h3>
                  <span className="text-xs text-gray-400">{f.type}</span>
                </div>
              </div>
              <div className="space-y-2 text-sm text-gray-500 mb-4 flex-1">
                <div className="flex items-start gap-2">
                  <i className="ri-map-pin-line text-[#1A365D] mt-0.5 flex-shrink-0"></i>
                  <span>{f.address}</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-time-line text-[#1A365D] flex-shrink-0"></i>
                  <span>{f.hours}</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-phone-line text-[#1A365D] flex-shrink-0"></i>
                  <span>{f.phone}</span>
                </div>
              </div>
              <p className="text-xs text-gray-400 leading-relaxed border-t border-gray-100 pt-4">{f.notes}</p>
            </div>
          ))}
        </div>

        <div className="bg-[#1A365D] rounded-xl p-8 text-center">
          <h3 className="font-serif text-2xl font-bold text-white mb-3">Eastman Employees: Skip the Post Office</h3>
          <p className="text-white/70 text-sm max-w-xl mx-auto leading-relaxed mb-6">
            If you&apos;re an Eastman Chemical employee renewing your passport, you don&apos;t need to visit a post office. Adult renewals are handled entirely by mail. We review your documents, submit to the processing center, and ship your new passport to your Kingsport address.
          </p>
          <a href="https://fastpassportcenter.com/checkout/" className="inline-flex items-center gap-2 bg-[#F6C344] text-[#1A365D] font-semibold px-8 py-3 rounded-lg hover:bg-[#e5b33f] transition-all whitespace-nowrap">
            Start Corporate Renewal
          </a>
        </div>
      </div>
    </section>
  );
}